// Auftragsbestaetigung erfassen — Kompositionswurzel des Moduls (Muster: einvoicing/EInvoicingView.js).
// UI-PARITAET (Welle 3): die View ist jetzt reiner Shell-Host — die komplette Navigation
// (Dashboard/Dokumente/Regelsets/Monitoring/Mail/Meldungen) lebt in components/shell/AbShell.js
// (Vorbild: components/LagerShell.js). Props aus der App-Registry-Fast-Path: { user, onBack,
// showSuccess, showError }.

import React from 'react';
import { useTheme } from '../../core/ui/ThemeContext';
import { useLanguage } from '../../core/i18n/LanguageContext';
import AbShell from './components/shell/AbShell';

const AuftragsbestaetigungView = ({ user, onBack, showSuccess, showError }) => {
  const { isDarkMode } = useTheme();
  const { t } = useLanguage();

  return (
    <AbShell
      user={user} isDarkMode={isDarkMode} t={t}
      onBack={onBack} showSuccess={showSuccess} showError={showError}
    />
  );
};

export default AuftragsbestaetigungView;
